// :cow: Cosmose CONFIDENTIAL :iso:
import { PlannerBasicDemoStepEnum } from '@med/app/home/planner-basic-demo/planner-basic-demo-step.enum';

export const plannerBasicDemoStepOrder: PlannerBasicDemoStepEnum[] = [
  PlannerBasicDemoStepEnum.campaignListAddNewCampaign,
  PlannerBasicDemoStepEnum.campaignObjectiveSelectNewStoreOpening,
  PlannerBasicDemoStepEnum.plannerStartSelectAudience,
  PlannerBasicDemoStepEnum.audienceShowEstimates,
  PlannerBasicDemoStepEnum.audienceReadSegmentDescriptions,
  PlannerBasicDemoStepEnum.audienceAnalyzeLocationCategories,
  PlannerBasicDemoStepEnum.audienceClickEditBusinessCategories,
  PlannerBasicDemoStepEnum.audienceExpandCategory,
  PlannerBasicDemoStepEnum.audienceSelectLocationCategories,
  PlannerBasicDemoStepEnum.audienceCloseLocationCategoriesDialog,
  PlannerBasicDemoStepEnum.audienceExplainAddingLocationCategories,
  PlannerBasicDemoStepEnum.audienceAskToSelectCity,
  PlannerBasicDemoStepEnum.audienceShowTimespan,
  PlannerBasicDemoStepEnum.audienceAskToClickContinue,
  PlannerBasicDemoStepEnum.demographicsSelectGender,
  PlannerBasicDemoStepEnum.demographicsAskToClickContinue,
  PlannerBasicDemoStepEnum.mediaSearchPlatform,
  PlannerBasicDemoStepEnum.mediaExpandPlatform,
  PlannerBasicDemoStepEnum.mediaSelectFormat,
  PlannerBasicDemoStepEnum.mediaAskToClickContinue,
  PlannerBasicDemoStepEnum.budgetSelectCampaignDuration,
  PlannerBasicDemoStepEnum.budgetCalculationExplanation,
  PlannerBasicDemoStepEnum.budgetAskToClickSummary,
  PlannerBasicDemoStepEnum.summaryAskToClickSendForReview,
  PlannerBasicDemoStepEnum.sentForReviewAskToClickBackToDashboard,
  PlannerBasicDemoStepEnum.campaignListExposeCampaign,
];
